import Emitter from "./Emitter";

export default class ClosePaytable extends Emitter {
    constructor(gb) {
        super(gb);
    }

    HABANERO2_handler(){
        this.emitGame({type: "togglePaytable"})
    }

    _default() {
        this.emitGame({ wpgaction: "closePaytable" });
    }
}
